import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { LOGO_URL } from "../lib/api";
import { Twitter, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data.categories || [])); }, []);
  const year = new Date().getFullYear();
  const link = "hover:text-foreground hover:underline decoration-[#FFBE06] decoration-2 underline-offset-4 transition-colors";
  const social = "icon-btn";
  return (
    <footer className="border-t border-border bg-paper-2" data-testid="app-footer">
      <div className="container-x py-14 grid grid-cols-2 md:grid-cols-5 gap-10 text-sm">
        <div className="col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <img src={LOGO_URL} alt="" className="h-9 w-9" />
            <span className="font-extrabold text-xl tracking-[-0.04em]">BHEGA</span>
          </div>
          <p className="text-muted-foreground max-w-sm leading-relaxed" data-testid="footer-tagline">
            Find your people. Build collective buying power. Get more value together — on cars, bikes, homes and electronics.
          </p>
          <div className="mt-5 space-y-1 text-xs text-muted-foreground" data-testid="footer-copyright-block">
            <p>&copy; {year} BHEGA. All rights reserved.</p>
            <p>
              A{" "}
              <a href="https://www.compubrain.com" target="_blank" rel="noopener noreferrer" className="font-bold text-foreground hover:text-brand transition-colors" data-testid="footer-compubrain-link">CompuBrain</a>{" "}
              venture.
            </p>
          </div>
          <div className="flex gap-2 mt-5">
            <a href="#" aria-label="BHEGA on Twitter" className={social} data-testid="footer-social-twitter"><Twitter size={15} /></a>
            <a href="#" aria-label="BHEGA on Instagram" className={social} data-testid="footer-social-instagram"><Instagram size={15} /></a>
            <a href="#" aria-label="BHEGA on LinkedIn" className={social} data-testid="footer-social-linkedin"><Linkedin size={15} /></a>
          </div>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Browse</h4>
          <ul className="space-y-2.5 text-muted-foreground">
            <li><Link to="/browse" className={link}>All rooms</Link></li>
            {cats.map((c) => <li key={c.slug}><Link to={`/${c.slug}`} className={link}>{c.label}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Platform</h4>
          <ul className="space-y-2.5 text-muted-foreground">
            <li><Link to="/how-it-works" className={link} data-testid="footer-how-it-works">How it works</Link></li>
            <li><Link to="/about" className={link} data-testid="footer-about-us">About Us</Link></li>
            <li><a href="#" className={link}>Trust &amp; safety</a></li>
            <li><a href="#" className={link}>Privacy</a></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow mb-4">For sellers</h4>
          <ul className="space-y-2.5 text-muted-foreground">
            <li><a href="#" className={link}>Verify your deals</a></li>
            <li><a href="#" className={link}>Get listed</a></li>
          </ul>
        </div>
      </div>
      <div className="container-x pb-8 md:pb-6 overflow-hidden">
        <div className="display-1 select-none text-foreground/[0.06] leading-none" aria-hidden>BHEGA ✊</div>
      </div>
    </footer>
  );
}
